
export default {
    namespaced: true,
    state: {
        searchEngineData: [],
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        typeList: [],
        searchEngineList: [],
        isSendingSAVE: false,
        timerSAVE: null,
        existChange: false,
        selectedType: 'en_ru',
        params: {
            search: null,
            sort: {
                dir: 'asc',
                field: 'id'
            }
        },
        deletedList: [],
        searchEngine: 'google'
    },
    getters: {
        GET_PREPARE_PARAMS: state => {
            return {
                'searchEngine': state.searchEngine,
                'page': state.currentPage,
                'pageSize': state.perPage <= 0 ? 1 : state.perPage,
                'search': state.params.search,
                'sort': state.params.sort.field,
                'sortDir': state.params.sort.dir
            };
        },
        DELETED_LIST: state => {
            return state.deletedList;
        },
        PARAMS: state => {
            return state.params;
        },
        SELECTED_TYPE: state => {
            return state.selectedType;
        },
        EXIST_CHANGE: state => {
            return state.existChange;
        },
        SEARCH_ENGINE_LIST: state => {
            return state.searchEngineList;
        },
        SEARCH_ENGINE_DATA: state => {
            return state.searchEngineData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        },
        SEARCH_ENGINE: (state) => {
            return state.searchEngine
        }
    },
    mutations: {
        SEARCH_ENGINE: (state, payload) => {
            return state.searchEngine = payload;
        },
        DELETED_LIST: (state, payload) => {
            return state.deletedList = payload;
        },
        ADD_TO_DELETED_LIST: (state, payload) => {
            return state.deletedList.push(payload);
        },
        PARAMS: (state, payload) => {
            return state.params = payload;
        },
        SELECTED_TYPE: (state, payload) => {
            return state.selectedType = payload;
        },
        EXIST_CHANGE: (state, payload) => {
            return state.existChange = payload;
        },
        SEARCH_ENGINE_LIST: (state, payload) => {
            return state.searchEngineList = payload;
        },
        SEARCH_ENGINE_DATA: (state, payload) => {
            return state.searchEngineData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        SAVE: async ({commit, state, dispatch, getters}, payload) => {
            if (state.isSendingSAVE) {
                if (state.timerSAVE != null) {
                    clearTimeout(state.timerSAVE);
                }
                state.timerSAVE = setTimeout(() => {
                    state.timerSAVE = null;
                    dispatch('SAVE', {th: payload.th});
                }, 2000);
            } else {
                let data = {
                    list: state.searchEngineData,
                    deleted: state.deletedList,
                    params: getters.GET_PREPARE_PARAMS
                };
                state.isSendingSAVE = true;
                payload.th.showOverlay ++;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/search-regions',
                    parameter: data,
                    th: payload.th,
                    showSuccessMessage: false,
                    getSuccessResponse: (responseData) => {
                        state.deletedList = [];
                        // prepare value
                        for (let key in responseData.data.list) {
                            let val = responseData.data.list[key]
                            if (val == undefined || val == null)
                                continue
                            if (val.brands == '') {
                                responseData.data.list[key].brands = [];
                            }
                            if (val.searchEngines == '') {
                                responseData.data.list[key].searchEngines = [];
                            }
                        }
                        console.log(responseData.data.list)
                        commit('SEARCH_ENGINE_DATA', responseData.data.list);
                        commit('TOTAL_ROWS', responseData.data.count);
                        commit('EXIST_CHANGE', false);
                    },
                    getResponse: () => {
                        state.isSendingSAVE = false;
                        payload.th.showOverlay --;
                    }
                });
            }
        },
        GET_DATA: async ({commit, getters}, payload) => {
            let params = getters.GET_PREPARE_PARAMS;
            params = JSON.stringify(params);
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/search-regions?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SEARCH_ENGINE_DATA', responseData.data.list);
                    commit('TOTAL_ROWS', responseData.data.count);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }
    }
}